import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

import './../../styles/home/services.css'; 
import manicureImage from './../../../src/resources/images/home/Services/manicura.jpg'; 
import pedicureImage from './../../../src/resources/images/services/Pedicura/pedicura2.jpg'; 
import hairImage from './../../../src/resources/images/services/PeloPeinados/pel.jpg'; 
import makeUpImage from './../../../src/resources/images/services/Maquillaje/maquillaje1.jpg'; 

const ServicesScroll = () => {
  const [currentIndex, setCurrentIndex] = useState(0); // Estado para controlar el índice del elemento actual
  const [fadeOut, setFadeOut] = useState(false);
  //const [prevImageVisible, setPrevImageVisible] = useState(false);
  const [nextImageVisible, setNextImageVisible] = useState(false);

  const ServicesObject = [
    {
      id: 1,
      imageUrl: manicureImage, 
      subtitle: 'Manicuras',
      description: 'Servicio profesional y dedicado para el cuidado y embellecimiento de tus manos.',
      buttonContent: 'Descubre nuestras manicuras',
      buttonRoute: 'services',
    },
    {
      id: 2,
      imageUrl: pedicureImage, 
      subtitle: 'Pedicuras',
      description: 'Tratamiento personalizado para el cuidado y embellecimiento de tus pies.',
      buttonContent: 'Descubre nuestras pedicuras',
      buttonRoute: 'services',
    },
    {
      id: 3,
      imageUrl: makeUpImage, 
      subtitle: 'Maquillaje',
      description: 'Maquillaje profesional adaptado a tus necesidades y preferencias.',
      buttonContent: 'Descubre nuestros maquillajes',
      buttonRoute: 'services',
    },
    {
      id: 4,
      imageUrl: hairImage, 
      subtitle: 'Peinado',
      description: 'Tratamientos capilares personalizados para realzar tu belleza natural.',
      buttonContent: 'Descubre nuestros tratamientos capilares',
      buttonRoute: 'services',
    },
  ];
  

  useEffect(() => {
    // Función para cambiar automáticamente el elemento cada 3 segundos
    /*
    const interval = setInterval(() => {
      setCurrentIndex(currentIndex => (currentIndex + 1) % ServicesObject.length);
    }, 5000);

    return () => {
      clearInterval(interval); // Limpiar el temporizador cuando el componente se desmonte
    };
    */

  }, [ServicesObject.length]); // Dependencia para volver a iniciar el temporizador si cambia la longitud de ServicesObject

  useEffect(() => {
    const timer = setTimeout(() => {
      //setPrevImageVisible(false);
      setNextImageVisible(false);
      setFadeOut(false); // Después de 0.5 segundos, desactivar el desvanecimiento
    }, 500);

    return () => clearTimeout(timer); // Limpiar el temporizador al desmontar el componente
  }, [fadeOut]); // Se ejecuta cada vez que cambia el estado de fadeOut

  const goToNextItem = () => {
    //setPrevImageVisible(true);
    setFadeOut(true);
    setTimeout(() => {
      setCurrentIndex((currentIndex + 1) % ServicesObject.length);
      setNextImageVisible(true);
    }, 500);
  };

  const goToPreviousItem = () => {
    setNextImageVisible(true);
    setFadeOut(true);
    setTimeout(() => {
      setCurrentIndex((currentIndex - 1 + ServicesObject.length) % ServicesObject.length);
      //setPrevImageVisible(true);
    }, 500);
  };

  return (
    <div className="services-component">
      <h2>Servicios</h2>
      <div className="services-home">
        <div className="services-item">
        <button className='arrowButton' onClick={goToPreviousItem}>&#8592;</button>
          <div className="services-image">
            <button className='arrowButton-mobile left' onClick={goToPreviousItem}>&#8592;</button>  
              {/*prevImageVisible && <img className={fadeOut ? 'fade-out' : 'fade-in'} src={ServicesObject[(currentIndex - 1 + ServicesObject.length) % ServicesObject.length].imageUrl} alt={`Imagen ${ServicesObject[currentIndex].id}`} /> /*/}
              <img className={fadeOut ? 'fade-out' : 'fade-in'} src={ServicesObject[currentIndex].imageUrl} alt={`Imagen ${ServicesObject[currentIndex].id}`} />
              {nextImageVisible && <img className={fadeOut ? 'fade-out' : 'fade-in'} src={ServicesObject[(currentIndex + 1) % ServicesObject.length].imageUrl} alt={`Imagen ${ServicesObject[currentIndex].id}`} />}
            <button className='arrowButton-mobile right' onClick={goToNextItem}>&#8594;</button>  
          </div>
          <div className="services-text">
            <h2 className="services-subtitle">{ServicesObject[currentIndex].subtitle}</h2>
            <p className="services-description">{ServicesObject[currentIndex].description}</p>
            <div className="services-button">
              <Link to={`/${ServicesObject[currentIndex].buttonRoute}`} className="button">
                {ServicesObject[currentIndex].buttonContent}
              </Link>
            </div>
          </div>  
          <button className='arrowButton' onClick={goToNextItem}>&#8594;</button>              
        </div>
      
      </div>
    </div>
  );
};

export default ServicesScroll;
